import { Box, Typography } from "@mui/material"
import { PageContainer } from "lib/@components/page-container"
import { AuthoringHomeTitle, AuthoringHomeTile } from "./authoring-home-slot-definitions"

export function AuthoringHomePage() {
    return (
        <PageContainer>
            <Typography
                component="span"
                sx={{
                    position: "absolute",
                    width: 1,
                    height: 1,
                    p: 0,
                    m: -1,
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    border: 0,
                }}
            >
                authoring system accessed
            </Typography>
            <AuthoringHomeTitle.Slot />
            <Box
                sx={{
                    display: "grid",
                    gap: 3,
                    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                    mt: 1,
                }}
            >
                <AuthoringHomeTile.Slot />
            </Box>
        </PageContainer>
    )
}
